import loadable from '@wix/yoshi-flow-editor/loadable';
import type { FormRendererProps, FormsI18n } from '@wix/communities-blog-client-common/components';

export type { FormRendererProps, FormsI18n };

/**
 * The chunk boundary for Wix Forms UI, kept behind this module so the import sites and the
 * `jest.mock('./form-renderer')` calls stay where they are.
 *
 * `ssr: false` is deliberate: the server never fetches this chunk. The block renders the same
 * placeholder the renderer would show while its field chunks load, so the server markup is
 * unchanged, and a freshly published or slow chunk cannot take the whole post body down with it
 * (ricos' viewer boundary renders nothing when a plugin throws during render).
 */
export const FormRenderer = loadable(
  () =>
    import(
      /* webpackChunkName: "wix-forms-renderer" */ '@wix/communities-blog-client-common/components'
    ).then((m) => ({ default: m.FormRenderer })),
  { ssr: false },
);
